import { combineLatest } from 'rxjs'
import { map as rxMap, filter } from 'rxjs/operators'
import { map, find } from 'libraries/lodash'
import { RESPONSE_PENDING } from 'libraries/front-end-core/constants/responses'
import { mapResponse } from 'libraries/front-end-core/helpers/dataflow'
import { LEGISLATION_REFERENCE } from 'constants/requests'
import { fetch } from 'services/ApiService'
import { requestActs } from './LegislationService'

const validateLinkability = function (references, acts) {
  // checks if references exist in legislation
  return map(references, reference => Object.assign({ linkable: !!find(acts, ['id', reference.context[0].id]) }, reference))
}

export const requestReferenceNodes = ({ references }) => combineLatest([
  fetch(LEGISLATION_REFERENCE, { references }),
  requestActs()
]).pipe(
  filter(([references, acts]) => references !== RESPONSE_PENDING && acts !== RESPONSE_PENDING),
  rxMap(([references, acts]) => mapResponse(validateLinkability)(references, acts))
)
